import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/geobooster'

Styxie.Initializers.MobileCheckins = {
  index: async(props) => {
    const { default: MomentsIndex } = await import('@/vue_widgets/geobooster/moments/index/index.vue')
    createVueApp(MomentsIndex, { props, sidebar })
  }
}
